import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSecondDisplay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.5 11.5v12H17V26H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h23a1 1 0 0 1 1 1v6h-2.5v-4.5zM39 37H24v2h15zM9 28h8v2H9zm11-10a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1zm1.5 2.5h20v12h-20z" })
});
export default SvgSecondDisplay;
